module.exports = {
  webWidget: {
    helpCenter: {
      chatButton: 'Chat with Reverb',
      title: 'Need Help?',
      searchPlaceholder: 'Search our FAQs',
    },
    launcher: {
      chatLabel: 'Chat with Reverb',
      label: 'Need Help?',
    },
    contactOptions: {
      contactButton: 'Contact Us',
    },
  },
  zopim: {
    window: {
      title: 'Chat with Reverb',
    },
    prechatForm: {
      greetings: 'Our resident musicians are standing by, ask us anything!',
    },
  },
};



// WEBPACK FOOTER //
// ./javascripts/translations/zendesk/en.js